import RepositoryFactory from '@/repository/RepositoryFactory';

const featureRepository = RepositoryFactory.manager.feature;

export const isExistFeatureFlag = async (featureName: string) => {
  try {
    const response = await featureRepository.isExistFlag(featureName);
    return response.status === 200 && response.data.isPublic;
  } catch (e) {
    return false;
  }
};
